import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SequelaeCard } from '@models/condition.models';
import { MarkdownPipe } from '@pipes/markdown.pipe';

@Component({
  selector: 'app-sequelae-card',
  standalone: true,
  templateUrl: './sequelae-card.component.html',
  styleUrls: ['./sequelae-card.component.scss'],
  imports: [CommonModule, MarkdownPipe],
})
export class SequelaeCardComponent {
  @Input() card!: SequelaeCard;
  @Input() headingLevel: number = 3;
}
